import { upload } from '../actions/actionTypes';
export const initialState = {
    showMenu: false,
    files: [],
    count: null,
};
export default function (state = initialState, action) {
    switch (action.type) {
        case upload.SHOW_MENU:
            return { ...state, showMenu: true };
        case upload.HIDE_MENU:
            return initialState;
        case upload.DISPATCH_FILES:
            const dispatchFilesPayload = action.payload;
            return { ...state, files: [...dispatchFilesPayload, ...state.files] };
        case upload.UPLOADED:
            const uploadedPayload = action.payload;
            return { ...state, [uploadedPayload.uriKey]: 1 };
        case upload.UPLOADING:
            const uploadingPayload = action.payload;
            return { ...state, [uploadingPayload.uriKey]: uploadingPayload.progress };
        case upload.COUNT:
            const countPayload = action.payload;
            return { ...state, count: countPayload };
        case upload.CLEAR:
            return initialState;
        default:
            return state;
    }
}
